import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, mergeProps as _mergeProps, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  class: "modal__wrapper",
  key: `modal`
}
const _hoisted_2 = { class: "modal__header" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "modal__body" }

import { computed, defineOptions } from 'vue';

import SmIconButton from '@/components/ui/buttons/SmIconButton/SmIconButton.vue';

import { IModalProps } from '@/@types/components/ui/modal';

import '@/components/ui/SmModal/style.scss';


export default /*#__PURE__*/_defineComponent({
  ...{ inheritAttrs: false },
  __name: 'SmModal',
  props: {
    modelValue: { type: Boolean, default: false },
    title: { default: '' },
    showClose: { type: Boolean, default: true },
    allowCloseByBackdrop: { type: Boolean, default: true }
  },
  emits: ['update:model-value', 'close'],
  setup(__props: any, { emit: emits }) {

const props = __props;





const value = computed({
  get: () => props.modelValue,
  set: (v) => {
    emits('update:model-value', v);
    emits('close');
  },
});

function onClose() {
  value.value = false;
}

function onClickBackdrop() {
  if (!props.allowCloseByBackdrop) return;
  onClose();
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      name: "modal",
      tag: "div"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _mergeProps(_ctx.$attrs, { class: "modal" }), [
          _createElementVNode("div", {
            class: "modal__backdrop",
            onClick: onClickBackdrop
          }),
          (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _renderSlot(_ctx.$slots, "header", {}, () => [
                _createElementVNode("p", {
                  class: "modal__title",
                  innerHTML: _ctx.title
                }, null, 8, _hoisted_3),
                (props.showClose)
                  ? (_openBlock(), _createBlock(SmIconButton, {
                      key: 0,
                      iconName: "Cross",
                      title: "Закрыть",
                      onClick: onClose
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "body")
            ]),
            _renderSlot(_ctx.$slots, "footer")
          ]))
        ], 16), [
          [_vShow, value.value]
        ])
      ]),
      _: 3
    })
  ]))
}
}

})